export function resizeImageToBase64(file: File, maxSize = 600): Promise<string> {
  return new Promise((resolve, reject) => {
    const img = new Image();
    const reader = new FileReader();

    reader.onload = () => {
      if (!reader.result) return reject("Failed to read file");

      img.src = reader.result as string;

      img.onload = () => {
        // Crop and resize the image to 600px x 600px max size.
        // Also make sure the aspect ratio is square.
        const canvas = document.createElement("canvas");
        
        const targetSize = Math.min(img.width, img.height, maxSize);
        if (targetSize === 0) return reject("Image has no valid dimensions");

        let start_x = 0;
        let start_y = 0;
        let sourceSize = Math.min(img.width, img.height);

        if (img.width > img.height) {
          start_x = (img.width - img.height) / 2;
        } else if (img.height > img.width) {
          start_y = (img.height - img.width) / 2;
        }        

        canvas.width = targetSize;
        canvas.height = targetSize;

        const ctx = canvas.getContext("2d");
        if (!ctx) return reject("Canvas not supported");

        ctx.drawImage(
          img,
          start_x,
          start_y,
          sourceSize,
          sourceSize,
          0,
          0,
          targetSize,
          targetSize
        );

        // Compress to JPEG at 80% quality
        const dataUrl = canvas.toDataURL("image/jpeg", 0.8);
        resolve(dataUrl);
      };

      img.onerror = reject;
    };

    reader.onerror = reject;
    reader.readAsDataURL(file);
  });
}


// Usage example in a component
// const handleAvatarUpload = async (e: React.ChangeEvent<HTMLInputElement>) => {
//   const file = e.target.files?.[0];
//   if (!file) return;

//   try {
//     const resized = await resizeImageToBase64(file);
//     setProfile(prev => prev ? { ...prev, avatar_data_url: resized } : prev);
//   } catch (err) {
//     console.error("Image resize failed:", err);
//   }
// };
